<div class="mb-4">
    <app-file-uploader #fileUploader [storage-strategy]="storageStrategy" (uploadFinished)="onUploadFinished($event)"></app-file-uploader>
</div>